"use client";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getFavoritesList,
  addFavorite,
  removeFavorite,
} from "../actions/favorites";
import { StoreFavorite } from "../models/store-favorite";
import { useToastStore } from "@/store/index";

export const useFavorites = () => {
  const queryClient = useQueryClient();
  const { showToast } = useToastStore();

  const {
    data: favorites,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["favorites"],
    queryFn: () => getFavoritesList().catch(() => []),
    staleTime: 0,
  });

  const addMutation = useMutation({
    mutationFn: addFavorite,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["favorites"] });
      showToast(
        "Se ha añadido correctamente este producto a su lista de Favoritos."
      );
    },
  });

  const removeMutation = useMutation({
    mutationFn: removeFavorite,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["favorites"] });
      showToast("Producto eliminado de su lista de Favoritos.");
    },
  });

  const isFavorite = (productId: string) => {
    return favorites?.some((f: StoreFavorite) => f.product_id === productId);
  };

  return {
    favorites,
    isLoading,
    refetchFavorites: refetch,
    addFavorite: addMutation.mutateAsync,
    removeFavorite: removeMutation.mutateAsync,
    isFavorite,
  };
};
